<template>
  <div class="container-sm">
    <nav class="navbar navbar-expand-lg text-center">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <img src="../assets/BurgerMenu.png" />
      </button>
      <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item pl-4" v-for="(link,i) in menuLinks" :key="link.id">
            <router-link :to="link.name">
              <a class="nav-link" @mouseover="moveGif(i)" @mouseout="removeGif">
                <img :src=link.srcHov v-if="index === i" class="img-responsive"/>
                <img :src=link.srcDflt v-else class="img-responsive"/>
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <div class="wrapper"></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    index: null,
    menuLinks: [
      {id: 1, name: 'random', srcDflt: require('../assets/Dice.png'), srcHov: require('../assets/gifs/Dice.gif')},
      {id: 2, name: 'songsearch', srcDflt: require('../assets/Search.png'), srcHov: require('../assets/gifs/Search.gif')},
      {id: 3, name: 'editorial', srcDflt: require('../assets/Editorial.png'), srcHov: require('../assets/gifs/Editorial.gif')},
      {id: 4, name: 'favourites', srcDflt: require('../assets/Favourites.png'), srcHov: require('../assets/gifs/Favourites.gif')},
      {id: 5, name: 'aboutus', srcDflt: require('../assets/AboutUs.png'), srcHov: require('../assets/gifs/AboutUs.gif')},
      {id: 6, name: 'user', srcDflt: require('../assets/User.png'), srcHov: require('../assets/gifs/UserGif.gif')}
    ]
  }),
  methods: {
    moveGif: function(i) {
     this.index = i
    },
    removeGif: function() {
     this.index = null
    }
  }
}
</script>

<style>

</style>